import { render, staticRenderFns } from "./ParticipantEarnedWidget.vue?vue&type=template&id=236e94dd"
import script from "./ParticipantEarnedWidget.vue?vue&type=script&lang=js"
export * from "./ParticipantEarnedWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports